import React, { useState } from 'react';
import { Box, Typography, Container, Card, CardContent, Button, TextField, InputAdornment } from '@mui/material';
import { GridContainer, GridItem } from '../components/CustomGrid';
import { Link, useNavigate } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';

const featuredPalms = [
  {
    name: 'Cocos nucifera',
    common: 'Coconut Palm',
    image: '/assets/coconut-palm.jpg',
    id: 1
  },
  {
    name: 'Elaeis guineensis',
    common: 'African Oil Palm',
    image: '/assets/oil-palm.jpg',
    id: 2
  },
  {
    name: 'Areca catechu',
    common: 'Betel Nut Palm',
    image: '/assets/betel-nut.jpg',
    id: 3
  }
];

const categories = [
  'Tropical',
  'Drought Tolerant',
  'Ornamental',
  'Fruit Bearing',
  'Native',
  'Rare'
];

const HomePage: React.FC = () => {
  const [search, setSearch] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    navigate(`/plants?search=${encodeURIComponent(search)}`);
  };

  return (
    <Container maxWidth="lg">
      {/* Hero Section */}
      <Box sx={{ py: 8, textAlign: 'center' }}>
        <Typography variant="h2" component="h1" gutterBottom>
          PalmGarden Encyclopedia
        </Typography>
        <Typography variant="h5" color="text.secondary" paragraph>
          Explore the world of palms. Search, browse, and learn about palm species from around the globe.
        </Typography>
        <Box component="form" onSubmit={handleSearch} sx={{ mt: 4, maxWidth: 500, mx: 'auto' }}>
          <TextField
            fullWidth
            placeholder="Search for a palm..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Box>
      </Box>

      {/* Featured Palms */}
      <Box sx={{ mt: 8 }}>
        <Typography variant="h4" gutterBottom>Featured Palms</Typography>
        <GridContainer spacing={4}>
          {featuredPalms.map(palm => (
            <GridItem xs={12} sm={6} md={4} key={palm.id}>
              <Card>
                <CardContent>
                  <Box sx={{ mb: 2, textAlign: 'center' }}>
                    <img src={palm.image} alt={palm.common} style={{ width: '100%', maxHeight: 180, objectFit: 'cover', borderRadius: 8 }} />
                  </Box>
                  <Typography variant="h6" gutterBottom>{palm.common}</Typography>
                  <Typography variant="body2" color="text.secondary" gutterBottom>{palm.name}</Typography>
                  <Button component={Link} to={`/plants/${palm.id}`} variant="outlined" size="small">View Details</Button>
                </CardContent>
              </Card>
            </GridItem>
          ))}
        </GridContainer>
      </Box>

      {/* Browse by Category */}
      <Box sx={{ mt: 8 }}>
        <Typography variant="h4" gutterBottom>Browse by Category</Typography>
        <GridContainer spacing={2}>
          {categories.map(cat => (
            <GridItem key={cat}>
              <Button component={Link} to={`/plants?category=${encodeURIComponent(cat)}`} variant="contained" color="primary" sx={{ borderRadius: 20, px: 4 }}>
                {cat}
              </Button>
            </GridItem>
          ))}
        </GridContainer>
      </Box>
    </Container>
  );
};

export default HomePage; 